var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 896",
    style: {
      enableBackground: "new 0 0 896 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_495",
    className: "st0",
    d: "M684.9-0.5H210.1C93.3-0.5-1,93.8-1,210.6v474.8c0,116.4,94.3,211.1,211.1,211.1l0,0h474.8 c116.4,0,211.1-94.3,211.1-210.7l0,0V210.6C896,94.2,801.3-0.5,684.9-0.5L684.9-0.5z M277.7,646.2V244l403.9,201.1L277.7,646.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.226f19676056f1f7b263a86ce49cab7a.svg";
export { ForwardRef as ReactComponent };